export default function Footer() {
    return (
        <footer className="Footer">
            <p className="Footer-text">Created @ <a href="https://junocollege.com">Juno College</a> 2022.</p>
        </footer>
    )
}